<div
  class="widget-wrapper"
  [class.interactive]="config().interactive"
  [class.has-panels]="hasAnyPanels()"
  [style.border]="borderStyle()"
>
  @if (config().interactive && config().title) {
    <div class="widget-header">
      <span class="widget-title">{{ config().title }}</span>
    </div>
  }
  @if (panelTopTables().length) {
    <div class="widget-panel widget-panel-top" [style.align-items]="getTableAlignCss(panelTopTables()[0].position)">
      @for (table of panelTopTables(); track table.id) {
        <dojo-data-table
          [columns]="table.columns"
          [rows]="table.rows"
          [showHeader]="table.showHeader ?? true"
          [label]="table.label"
          [resolveValue]="getResolveValue()"
          (rowHover)="onTableRowHover($event)"
          (rowLeave)="onTableRowLeave($event)"
        />
      }
    </div>
  }
  <div class="widget-body" [class.has-horizontal-panels]="hasHorizontalPanels()">
    @if (panelLeftTables().length) {
      <div
        class="widget-panel widget-panel-left"
        [style.justify-content]="getTableAlignCss(panelLeftTables()[0].position)"
      >
        @for (table of panelLeftTables(); track table.id) {
          <dojo-data-table
            [columns]="table.columns"
            [rows]="table.rows"
            [showHeader]="table.showHeader ?? true"
            [label]="table.label"
            [resolveValue]="getResolveValue()"
            (rowHover)="onTableRowHover($event)"
            (rowLeave)="onTableRowLeave($event)"
          />
        }
      </div>
    }
    <div class="widget-main" [class.canvas-standalone]="hasAnyPanels()" [style.border]="canvasBorderStyle()">
      <div class="widget-canvas">
        <div #widgetContainer class="widget-content"></div>
        @if (topLeftControls().length) {
          <div class="widget-overlay widget-overlay-top-left">
            @for (item of topLeftControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
        @if (topControls().length) {
          <div class="widget-overlay widget-overlay-top">
            @for (item of topControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
        @if (topRightControls().length) {
          <div class="widget-overlay widget-overlay-top-right">
            @for (item of topRightControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
        @if (bottomLeftControls().length) {
          <div class="widget-overlay widget-overlay-bottom-left">
            @for (item of bottomLeftControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
        @if (bottomControls().length) {
          <div class="widget-overlay widget-overlay-bottom">
            @for (item of bottomControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
        @if (bottomRightControls().length) {
          <div class="widget-overlay widget-overlay-bottom-right">
            @for (item of bottomRightControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        }
      </div>
      @if (sliderFooterControls().length) {
        <div class="widget-slider-footer" [class.minimal]="isFooterMinimal()">
          <div class="slider-footer-grid">
            @for (item of sliderFooterControls(); track $index) {
              <ng-container [ngTemplateOutlet]="controlOrGroupTemplate" [ngTemplateOutletContext]="{ item }" />
            }
          </div>
        </div>
      }
    </div>
    @if (panelRightTables().length) {
      <div
        class="widget-panel widget-panel-right"
        [style.justify-content]="getTableAlignCss(panelRightTables()[0].position)"
      >
        @for (table of panelRightTables(); track table.id) {
          <dojo-data-table
            [columns]="table.columns"
            [rows]="table.rows"
            [showHeader]="table.showHeader ?? true"
            [label]="table.label"
            [resolveValue]="getResolveValue()"
            (rowHover)="onTableRowHover($event)"
            (rowLeave)="onTableRowLeave($event)"
          />
        }
      </div>
    }
  </div>
  @if (panelBottomTables().length) {
    <div
      class="widget-panel widget-panel-bottom"
      [style.align-items]="getTableAlignCss(panelBottomTables()[0].position)"
    >
      @for (table of panelBottomTables(); track table.id) {
        <dojo-data-table
          [columns]="table.columns"
          [rows]="table.rows"
          [showHeader]="table.showHeader ?? true"
          [label]="table.label"
          [resolveValue]="getResolveValue()"
          (rowHover)="onTableRowHover($event)"
          (rowLeave)="onTableRowLeave($event)"
        />
      }
    </div>
  }
</div>

<ng-template #controlOrGroupTemplate let-item="item">
  @if (isGroup(item)) {
    <div class="input-group" [class.minimal]="isMinimalItem(item)">
      @for (control of item.controls; track control.id) {
        <ng-container [ngTemplateOutlet]="controlTemplate" [ngTemplateOutletContext]="{ control }" />
      }
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="controlTemplate" [ngTemplateOutletContext]="{ control: item }" />
  }
</ng-template>

<ng-template #controlTemplate let-control="control">
  @switch (control.type) {
    @case ('button') {
      <button
        class="widget-control-btn"
        [class.icon-only]="control.icon && !shouldShowLabel(control)"
        [attr.aria-label]="control.label"
        [title]="control.label"
        (click)="onButtonClick(control)"
      >
        @if (control.icon) {
          <dojo-icon [icon]="asIcon(control.icon)" />
        }
        @if (shouldShowLabel(control)) {
          <span class="btn-label" [dojoRichText]="control.label"></span>
        }
      </button>
    }
    @case ('button-group') {
      <div class="button-group">
        @for (btn of control.buttons; track btn.id) {
          <button
            class="widget-control-btn segment-btn"
            [class.active]="activeButtonInGroup()[control.id] === btn.id"
            [attr.aria-label]="btn.label"
            [title]="btn.label"
            (click)="onButtonGroupClick(control, btn)"
          >
            @if (btn.icon) {
              <dojo-icon [icon]="asIcon(btn.icon)" />
            }
            @if (shouldShowLabel(btn)) {
              <span class="btn-label" [dojoRichText]="btn.label"></span>
            }
          </button>
        }
      </div>
    }
    @case ('slider') {
      <dojo-slider
        [param]="control.label"
        [min]="getSliderMin(control)"
        [max]="getSliderMax(control)"
        [step]="getSliderStep(control)"
        [value]="getSliderValue(control)"
        [editable]="control.editable ?? false"
        [color]="control.color ?? 'sky'"
        [variant]="control.variant ?? 'default'"
        (valueChange)="onSliderChange(control, $event)"
      />
    }
    @case ('slider-group') {
      <div class="slider-group">
        @for (slider of control.sliders; track slider.id) {
          <dojo-slider
            [param]="slider.label"
            [min]="getSliderMin(slider)"
            [max]="getSliderMax(slider)"
            [step]="getSliderStep(slider)"
            [value]="getSliderGroupValue(control, slider.id)"
            [editable]="slider.editable ?? false"
            [color]="slider.color ?? 'sky'"
            [variant]="slider.variant ?? 'default'"
            (valueChange)="onSliderGroupChange(control, { id: slider.id, value: $event })"
          />
        }
      </div>
    }
    @case ('math-input') {
      <dojo-math-input
        [param]="control.param"
        [value]="getMathInputValue(control)"
        (valueChange)="onMathInputChange(control, $event)"
      />
    }
  }
</ng-template>
